import { inject, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';
import { Subscription } from 'rxjs';
import { EventsService } from '@services/events/events.service';
import { PaymentV2Service } from '@services/payment-v2/payment-v2.service';
import { UtilService } from '@services/util/util.service';
import { VariablesService } from '@services/variables/variables.service';
import { IOrder } from '@models/order.model';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { CurrencyIconComponent } from '@core-components/currency-icon/currency-icon.component';
import { LivesCountComponent } from '../../../lives-count/lives-count.component';
import { PaymentSipDonorsComponent } from '@common-components/payment-sip-donors/payment-sip-donors.component';

@Component({
  selector: 'app-redeem-thank-you-page',
  standalone: true,
  imports: [
    NgIf,
    RouterModule,
    MatButtonModule,
    CurrencyIconComponent,
    LivesCountComponent,
    PaymentSipDonorsComponent
  ],
  templateUrl: './redeem-thank-you-page.component.html',
  styleUrls: ['./redeem-thank-you-page.component.scss']
})
export class RedeemThankYouPageComponent {

  public paymentV2 = inject(PaymentV2Service);
  public vars = inject(VariablesService);
  public util = inject(UtilService);
  private events = inject(EventsService);

  @Input() order: IOrder;
  public lastOrder;
  private subscription: Subscription = new Subscription();
  private eventSub: Subscription = new Subscription();
  prizeAmount;
  currency;

  ngOnInit() {
    this.subscription = this.vars.lastOrderInfo.subscribe(res => this.lastOrder = res);
    this.eventSub = this.events.sendSystemEvent({
      eventName: 'sip_quiz',
      info_1: 'quiz_redeem',
      info_3: 'impact'
    }).subscribe(_ => _);
  }

  ngOnChanges() {
    if (this.order?.iso_currency !== this.currency) {
      this.prizeAmount = this.util.getPrizeAmount(this.order?.iso_currency);
      this.currency = this.order?.iso_currency;
    }
  }

  /**
   * On Payment button click
   */
  onPaymentClick() {
    this.events.sendSystemEvent({
      eventName: 'give_monthly_new',
      info_1: 'position',
      info_2: '43',
      info_3: 'impact',
    }).subscribe(_ => _);
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    if (this.eventSub) {
      this.eventSub.unsubscribe();
    }
  }
}
